import React from 'react'

import { useState, useRef, useEffect } from 'react'

import {
  TableContainer,
  TableRow,
  Box,
  Button,
  Typography,
  TableBody,
  Table,
  TableCell,
  Collapse,
  Tooltip,
} from '@mui/material'

import { IconButton } from '@mui/material'

import Arrow from 'atoms/Arrow'
import Discover from 'assets/images/icons/discover.png'
import {
  AccountBalance,
  Check,
  CreditCard,
  Home,
  InfoOutlined,
  Link,
  LocalHospital,
  MedicalServices,
  People,
  RequestQuote,
  Savings,
  VolunteerActivism,
  ChildCare,
} from '@mui/icons-material'

import { useModal } from 'components/modals'
import { QuilttLogo } from 'components/QuilttLogo'
import signalLogo from 'assets/images/logos/signalLogo.png'
import CountUp from 'react-countup'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const iconMap = {
  checkingsavings: Savings,
  property: Home,
  creditcard: CreditCard,
  investment: AccountBalance,
  mortgage: Home,
  charity: VolunteerActivism,
  alotchecking: Savings,
  alotother: Savings,
  alotsavings: Savings,
  fdvv: LocalHospital,
  fdvd: LocalHospital,
  ltc: LocalHospital,
  visiondental: LocalHospital,
  extratax: RequestQuote,
  uniondues: People,
  fsa: MedicalServices,
  hsa: MedicalServices,
  vbp: MedicalServices,
  child: ChildCare,
}
const AccountIconSelector = ({ subType, ...props }) => {
  const IconComponent = iconMap[subType] || AccountBalance
  return <IconComponent {...props} />
}

export const CallToActionRow = ({ text, onClick = () => {} }) => (
  <TableRow
    sx={{
      cursor: 'pointer',
      borderRadius: '200px',
    }}
    onClick={() => {
      onClick()
    }}
  >
    <TableCell
      colSpan={1}
      sx={{
        textAlign: 'center',
        alignItems: 'center',
        width: '25px',
        paddingLeft: '22px',
        paddingRight: '0px',
      }}
    >
      <svg
        style={{ marginTop: '4px' }}
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 8.91309H8V14.9131H6V8.91309H0V6.91309H6V0.913086H8V6.91309H14V8.91309Z"
          fill="#2370ED"
        />
      </svg>
    </TableCell>
    <TableCell colSpan={5} sx={{ paddingLeft: '10px' }}>
      <Typography variant="body3">{text}</Typography>
    </TableCell>
  </TableRow>
)

export const AccountRow = ({
  name,
  amount,
  img = '',
  subType = '',
  accountObject = {},
  symbol = '',
  infoText = '',
  linked = false,
  isCurrency = true,
  onClick = () => {},
  signalLinked = false,
}) => (
  <TableRow
    sx={{
      cursor: 'pointer',
      borderBottom: '1px solid #D2D6DA',
      '&:last-of-type': { borderBottom: 'none' },
      '&:hover': { backgroundColor: '#f6f6f6' },
      '&:first-of-type>td:first-of-type': {
        borderRadius: '20px 0 0 0',
      },
      '&:first-of-type>td:last-of-type': {
        borderRadius: '0 20px 0 0',
      },
      '&:last-of-type>td:first-of-type': {
        borderRadius: '0 0 0 20px',
      },
      '&:last-of-type>td:last-of-type': {
        borderRadius: '0 0 20px 0',
      },
      '&:only-of-type>td:first-of-type': {
        borderRadius: '20px 0 0 20px',
      },
      '&:only-of-type>td:last-of-type': {
        borderRadius: '0 20px 20px 0',
      },
    }}
    onClick={() => {
      onClick()
    }}
  >
    <TableCell
      colSpan={1}
      sx={{
        textAlign: 'center',
        alignItems: 'center',
        width: '25px',
        paddingLeft: { xs: '12px', md: '24px' },

        paddingRight: '0px',
        border: 'none',
      }}
    >
      <Box sx={{ width: '25px', height: '25px' }}>
        {img === '' || img === 'icon' ? (
          <IconButton
            aria-label="edit"
            size="small"
            sx={{
              padding: 0,
              marginTop: '-5px',
            }}
          >
            <AccountIconSelector fontSize="inherit" subType={subType} />
          </IconButton>
        ) : (
          <img
            style={{
              objectFit: 'contain',
              border: '1px solid #f1f1f1',
              borderRadius: '50px',
              width: '25px',
              height: '25px',
            }}
            src={img}
            alt=""
          />
        )}
      </Box>
    </TableCell>
    <TableCell
      colSpan={2}
      sx={{
        textAlign: 'left',
        border: 'none',
        paddingLeft: { xs: '5px', md: '10px' },
      }}
    >
      <Typography variant="body1Medium">
        {name}
        {infoText && (
          <Tooltip title={infoText} placement="top">
            <IconButton sx={{ padding: 0, margin: '-4px 0 0 8px' }}>
              <InfoOutlined />
            </IconButton>
          </Tooltip>
        )}
      </Typography>
    </TableCell>
    <TableCell sx={{ border: 'none', pr: { xs: 2, md: 4 } }}>
      <Box display="flex" alignItems="center" justifyContent="flex-end">
        {accountObject?.type === 'deduction' && (
          <Typography
            textAlign="right"
            color={accountObject?.keepInRetirement ? 'green' : 'red'}
            variant="body2"
            sx={{
              marginRight: '10px',
              '&>svg': {
                marginRight: '5px',
                marginBottom: '-2px',
              },
            }}
          >
            {accountObject?.keepInRetirement ? (
              <>
                <Check />
                Keeping in Retirement
              </>
            ) : (
              <>NOT Keeping in Retirement</>
            )}
          </Typography>
        )}
        <Typography textAlign="right" variant="body2" display="flex">
          {linked && (
            <>
              {signalLinked ? (
                // <Box
                //   sx={{
                //     display: 'block',
                //     position: 'absolute',
                //   }}
                // >
                //   <img
                //     src={signalLogo}
                //     style={{
                //       width: '28px',
                //       height: '28px',
                //       borderRadius: '50%',
                //     }}
                //   />
                // </Box>
                <img
                  src={signalLogo}
                  style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    marginRight: '8px',
                  }}
                />
              ) : (
                <Link
                  sx={{
                    height: '20px',
                    width: '20px',
                    marginBottom: '-4px',
                    color: '#4F8DF0',
                  }}
                />
              )}
            </>
          )}
          {isCurrency ? `${symbol} ${dollarFormat.format(amount)}` : amount}
        </Typography>
      </Box>
    </TableCell>
  </TableRow>
)

export const SubTableRow = ({ colSpan = 4, children }) => (
  <TableRow>
    <TableCell colSpan={colSpan} sx={{ padding: '0' }}>
      {children}
    </TableCell>
  </TableRow>
)

export function AssetInnerTable({
  rows,
  addAccountRow,
  demoMode = false,
  onAddClick,
  openModal,
  getAccounts,
  openToPage,
}) {
  const handleAdd = () => {
    if (demoMode) return
    if (onAddClick) {
      onAddClick()
    } else if (openModal && addAccountRow) {
      openModal('addAccounts', {
        getAccounts,
        openToPage: openToPage,
      })
    }
  }

  return (
    <>
      <Box
        sx={{
          borderRadius: { xs: '12px', md: '20px' },
          m: 1,
          mb: 0.5,
          border: '2px solid #D2D6DA',
          backgroundColor: '#FCFDFF',
        }}
      >
        <Table
          sx={{
            '& > *': { borderBottom: '1px solid #D2D6DA' },
            '& > *:last-of-type ': { borderBottom: 'none' },
            borderRadius: { xs: '12px', md: '20px' },
          }}
        >
          <TableBody>
            {rows.map((row, i) => (
              <React.Fragment key={i}>{row}</React.Fragment>
            ))}
          </TableBody>
        </Table>
      </Box>

      {addAccountRow && (
        <Button
          variant="contained"
          onClick={handleAdd}
          sx={{
            ml: 1.5,
            my: 2,
            padding: '8px 24px',
            backgroundColor: '#262627',
            border: '2px solid #262627',
            color: '#fff',
            boxShadow: 'none',
            borderRadius: '100px',
            textTransform: 'capitalize',
            fontWeight: 600,
            fontSize: { xs: '14px', md: '18px' },
            lineHeight: 1.5,
            '&:hover, &:focus, &:active, &:focus:not(:hover)': {
              backgroundColor: '#262627fa',
              borderColor: '#262627fa',
              boxShadow: 'none',
            },
          }}
        >
          {addAccountRow && addAccountRow}
        </Button>
      )}
    </>
  )
}

function AnimatedValue({ value, formatter }) {
  const lastRef = React.useRef(value)

  // Update the ref after each render — stores the previous value
  React.useEffect(() => {
    lastRef.current = value
  }, [value])

  return (
    <CountUp
      start={lastRef.current}
      end={value}
      duration={0.5}
      formattingFn={formatter}
    />
  )
}

function AssetsTable({
  rows,
  color = 'red',
  getAccounts,
  demoMode,
  isAdmin = false,
  openByDefault = [],
  styleAdjust = false,
  startingType = '',
}) {
  const { openModal } = useModal()
  const [open, setOpen] = useState(openByDefault)
  const [hoveredRow, setHoveredRow] = useState(null)

  const isActive = (index) => open.includes(index)

  const handleRowClick = (index) => {
    setOpen((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    )
  }

  const getRowColor = (index) => {
    if (hoveredRow === index) {
      return isActive(index) ? '#f1f1f1' : '#f9f9f9'
    }
    return isActive(index) ? '#f1f1f1' : 'inherit'
  }

  const renderExpandableRow = (index) => (
    <>
      <TableRow
        onMouseEnter={() => setHoveredRow(index)}
        onMouseLeave={() => setHoveredRow(null)}
        //cancels the color changing if not expandable
        onClick={() =>
          rows[index].expandable
            ? handleRowClick(index)
            : rows[index].clickAction
            ? rows[index].clickAction()
            : undefined
        }
        sx={{
          backgroundColor: rows[index].expandable
            ? getRowColor(index)
            : rows[index].lifeStyleStyling
            ? '#E4F0FF'
            : 'inherit',
          cursor:
            rows[index].expandable || rows[index].lifeStyleStyling
              ? 'pointer'
              : 'default',
          borderBottom: rows[index].expandable
            ? 'none'
            : index == rows.length - 1
            ? 'none'
            : '1px solid #e9ecef',
          borderTop:
            index === 0
              ? 'none'
              : rows[index].expandable
              ? '1px solid #e9ecef'
              : index == rows.length - 1
              ? '2px solid #D2D6DA'
              : 'none',
          transition: 'background-color 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: rows[index].expandable
              ? getRowColor(index)
              : rows[index].lifeStyleStyling
              ? '#cbe2ff'
              : 'inherit',
          },
          '&>td': {
            border: 'none',
          },
        }}
      >
        <TableCell
          colSpan={3}
          // size="large"
          sx={{ paddingLeft: { xs: '12px', md: '24px' } }}
        >
          <Typography
            variant={styleAdjust ? 'h4' : 'body2'}
            sx={{ color: rows[index].lifeStyleStyling ? '#2370ED' : 'default' }}
          >
            {rows[index].header}
          </Typography>
        </TableCell>
        <TableCell colSpan={2} sx={{ textAlign: 'right' }}>
          <Typography
            variant={styleAdjust ? 'h4' : 'body1Medium'}
            sx={{
              backgroundColor: rows[index].styledValue
                ? color === 'gray'
                  ? '#E4F0FF'
                  : 'transparent'
                : 'transparent',
              color: rows[index].styledValue
                ? color === 'gray'
                  ? '#2370ED'
                  : 'default'
                : rows[index].lifeStyleStyling
                ? '#2370ED'
                : 'default',
              padding: rows[index].styledValue ? '8px 24px' : '0px',
              borderRadius: rows[index].styledValue ? '8px' : '0px',
              marginRight: rows[index].styledValue ? '-24px' : '0px',
            }}
          >
            {!demoMode &&
              !rows[index].valueCounter &&
              dollarFormat.format(rows[index].headerValue)}
            {demoMode && '$X,XXX'}
            {!demoMode && rows[index].valueCounter && (
              <AnimatedValue
                value={rows[index].headerValue}
                formatter={(val) => dollarFormat.format(val)}
              />
            )}
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            width: '25px',
            padding: 0,
            paddingRight: { xs: '8px', md: '16px' },
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            {rows[index].expandable && (
              <Arrow
                color={
                  isActive(index)
                    ? color
                    : hoveredRow === index
                    ? color
                    : color + 'Inactive'
                }
                direction="down"
                hovered={hoveredRow == index}
                isOpen={isActive(index)}
              />
            )}
          </Box>
        </TableCell>
      </TableRow>

      {rows[index].expandable && (
        <>
          <TableRow
            sx={{
              backgroundColor: getRowColor(index),
              transition: 'background-color 0.2s ease-in-out',
              '& > *': { borderBottom: 'none' },
            }}
          >
            {rows[index].content && (
              <TableCell
                sx={{ paddingBottom: 0, paddingTop: 0, borderBottom: 'none' }}
                colSpan={6}
              >
                <Collapse in={open.includes(index)}>
                  <Box
                    sx={{
                      borderRadius: { xs: '12px', md: '20px' },
                      margin: 1,
                      marginBottom: 2,
                      marginTop: 0,
                      border: '2px solid #D2D6DA',
                      backgroundColor: '#FCFDFF',
                    }}
                  >
                    <Table
                      sx={{
                        '& > *': { borderBottom: '1px solid #D2D6DA' },
                        '& > *:last-of-type ': {
                          borderBottom: 'none',
                        },
                        borderRadius: { xs: '12px', md: '20px' },
                      }}
                    >
                      {rows[index].content}
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            )}
          </TableRow>

          {/* LINK A blank ROW */}
          {rows[index].addAccountRow && (
            <TableRow
              sx={{
                backgroundColor: getRowColor(index),
                transition: 'background-color 0.2s ease-in-out',
                '& > *': { borderBottom: 'none' },
              }}
            >
              <TableCell
                sx={{ paddingBottom: 0, paddingTop: 0, borderBottom: 'none' }}
                colSpan={6}
              >
                <Collapse in={open.includes(index)}>
                  <Button
                    variant="parcoRounded"
                    color="black"
                    onClick={() => {
                      if (!demoMode) {
                        openModal('addAccounts', {
                          getAccounts: getAccounts,
                          openToPage: rows[index].addAccountRow,
                          isAdmin: isAdmin,
                          startingType: startingType,
                        })
                      }
                    }}
                    // disabled={}
                    sx={{
                      ml: 1.5,
                      mb: 2,
                    }}
                  >
                    {rows[index].addAccountRow[0] == 'I' ||
                    rows[index].addAccountRow[0] == 'E' ? (
                      '+ Add an Income or Expense'
                    ) : rows[index].addAccountRow[0] == 'D' ? (
                      '+ Add a Deduction'
                    ) : (
                      <>
                        + Link{' '}
                        {rows[index].addAccountRow[0] == 'A' ? 'an' : 'a'}{' '}
                        {rows[index].addAccountRow}
                      </>
                    )}
                  </Button>
                </Collapse>
              </TableCell>
            </TableRow>
          )}
        </>
      )}
    </>
  )

  return (
    <TableContainer
      sx={{
        margin: 'auto',
        boxShadow: styleAdjust && 'none',
        '&>table>tbody>tr': {
          backgroundColor: styleAdjust && '#fff',
        },
        width: '100%',
        // borderTopLeftRadius: 0,
        // borderTopRightRadius: 0,
      }}
    >
      <Table aria-label="collapsible table">
        <TableBody sx={{ paddingY: '6px' }}>
          {rows.map((row, i) => (
            <React.Fragment key={i}>{renderExpandableRow(i)}</React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default AssetsTable
